import { render, staticRenderFns } from "./EstadoCuenta.vue?vue&type=template&id=6bf0cf02&scoped=true"
import script from "./EstadoCuenta.vue?vue&type=script&lang=js"
export * from "./EstadoCuenta.vue?vue&type=script&lang=js"
import style0 from "./EstadoCuenta.vue?vue&type=style&index=0&id=6bf0cf02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf0cf02",
  null
  
)

export default component.exports